import ReactModal from "react-modal";
import { Check, CloseModalIcon, Location } from "../../assets";
import { useState } from "react";
import { Email, generateEmailBody } from "../../assets/common";
import { Tooltip } from "react-tooltip";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ImageGallery from "react-image-gallery";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const ServiceCard = ({ service }) => {
  const { img, tag, location, propertyName, bhk, amenities, contactNumber } =
    service;
  const formFields = ["name", "phoneNumber", "email", "propertyName"];
  const initialFormData = formFields.reduce((formData, fieldName) => {
    formData[fieldName] = "";
    return formData;
  }, {});

  const [rentingServiceQueryFormData, setRentingServiceQueryFormData] =
    useState(initialFormData);
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const handleRentingServiceQueryForm = (event) => {
    setRentingServiceQueryFormData((previousData) => ({
      ...previousData,
      [event.target.name]: event.target.value,
    }));
  };

  const isFormValid = Object.entries(rentingServiceQueryFormData).some(
    ([key, value]) => {
      if (key === "propertyName") {
        return false;
      }

      // Check if the value is empty or contains only spaces or special characters
      else if (value.trim() === "" || /^[^\w\s]+$/.test(value)) {
        return true;
      } else {
        return false;
      } // Valid if the value is not empty and doesn't contain only spaces or special characters
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();

    const newFormData = {
      ...rentingServiceQueryFormData,
      propertyName: propertyName,
    };
    setRentingServiceQueryFormData(initialFormData);
    setRentingServiceQueryFormData((prevData) => ({
      ...prevData,
      address: "",
      message: "",
    }));
    Email.send({
      Host: process.env.REACT_APP_SMTP_HOST,
      Username: process.env.REACT_APP_SMTP_HOST_USER,
      Password: process.env.REACT_APP_SMTP_HOST_PASS,
      To: rentingServiceQueryFormData.email,
      From: process.env.REACT_APP_SMTP_HOST_USER,
      Subject: "WEBSITE ENQUIRY!",
      Body: "<h1>Thankyou!</h1>",
    }).then((message) => {
      toast.success("Message Sent successfully!");
      setShowModal(false);
    });

    Email.send({
      Host: process.env.REACT_APP_SMTP_HOST,
      Username: process.env.REACT_APP_SMTP_HOST_USER,
      Password: process.env.REACT_APP_SMTP_HOST_PASS,
      From: rentingServiceQueryFormData.email,
      To: process.env.REACT_APP_SMTP_HOST_USER,
      Subject: "WEBSITE ENQUIRY!",
      Body: generateEmailBody(newFormData),
    });

    // rentingServiceQueryFormData({});
  };

  const whatsappMessage = `📞🏡 Hi Sunland Investments LLC! 🌞%0A%0AI'm interested in your renting services for the property "${propertyName}." 🏠 Could you please provide more details about the rental options available? 🤔%0A%0AAdditionally, I'd like to know if you also offer maintenance services to ensure the property stays in top-notch condition. 🛠️💼%0A%0ALooking forward to hearing from you and exploring your services! 🏢%0A%0AThank you! 😊`;
  return (
    <>
      <div
        className="service-card-wrapper"
        onClick={() => setShowDetailsModal(!showDetailsModal)}
      >
        <div className="service-card-head-container">
          <Carousel
            responsive={responsive}
            swipeable={true}
            draggable={true}
            showDots={true}
            infinite
            autoPlay={true}
            autoPlaySpeed={3000}
            dotListClass="custom-dot-list-style"
            removeArrowOnDeviceType={[
              "tablet",
              "mobile",
              "desktop",
              "superLargeDesktop",
            ]}
          >
            {img.map((propertyImage, index) => {
              return (
                <img
                  key={index}
                  className="service-card-image"
                  src={propertyImage.original}
                  alt={propertyName}
                />
              );
            })}
          </Carousel>
          <span className="service-tag"> {tag} </span>
        </div>
        <div className="service-card-body-container">
          <div className="service-details-wrapper">
            <div className="location-wrapper">
              <Location />
              <span className="location"> {location} </span>
            </div>
            <p className="property-name"> {propertyName} </p>
            <p className="bhk-details"> {bhk} BHK Apartments </p>
          </div>
          <hr className="divider-line" />
          <div className="service-amenities-wrapper">
            {amenities.map((amenity, index) => {
              return (
                <div
                  key={index}
                  className="amenity-badge"
                  onClick={(e) => e.stopPropagation()}
                >
                  <a id={amenity.name}>{amenity.icon}</a>
                  <Tooltip
                    anchorSelect={"#" + amenity.name}
                    content={amenity.name}
                  />
                </div>
              );
            })}
          </div>
          <hr className="divider-line" />
          <div className="service-card-footer-action-button-wrapper">
            <a
              href={`https://api.whatsapp.com/send?phone=971509080595&text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="call-now-button"> WhatsApp </button>
            </a>
            <button
              className="enquire-button"
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(true);
              }}
            >
              {" "}
              Enquire{" "}
            </button>
          </div>
        </div>
      </div>
      <ReactModal
        className="modal-content"
        overlayClassName="modal-overlay"
        isOpen={showModal}
      >
        <div className="react-modal-content-wrapper">
          <div className="modal-header">
            <h4 className="modal-title"> Request A Service </h4>
            <div
              className="modal-close-icon-container"
              onClick={() => setShowModal(false)}
            >
              <CloseModalIcon />
            </div>
          </div>
          <div className="modal-body-container">
            <div className="input-fields-wrapper">
              {formFields.map((fieldName) =>
                fieldName === "phoneNumber" ? (
                  <input
                    key={fieldName}
                    name={fieldName}
                    placeholder="Phone Number"
                    onChange={handleRentingServiceQueryForm}
                    value={rentingServiceQueryFormData[fieldName]}
                    type="number"
                    required
                  />
                ) : (
                  <input
                    key={fieldName}
                    name={fieldName}
                    placeholder={`Your ${
                      fieldName === "email"
                        ? "Email"
                        : fieldName === "propertyName"
                        ? "Property Name"
                        : fieldName
                    } *`}
                    onChange={handleRentingServiceQueryForm}
                    value={
                      fieldName === "propertyName"
                        ? propertyName
                        : rentingServiceQueryFormData[fieldName]
                    }
                    disabled={fieldName === "propertyName"}
                    type={fieldName === "email" ? "email" : "text"}
                    required
                  />
                )
              )}
            </div>
            <input
              name="address"
              placeholder="Address *"
              onChange={handleRentingServiceQueryForm}
              value={rentingServiceQueryFormData.address}
              required
            />
            <textarea
              name="message"
              placeholder="Additional message"
              rows={4}
              onChange={handleRentingServiceQueryForm}
              value={rentingServiceQueryFormData.message}
              required
            ></textarea>
            <button
              disabled={isFormValid}
              className="submit-button"
              onClick={handleSubmit}
            >
              Request Service
            </button>
          </div>
        </div>
      </ReactModal>
      <ReactModal
        className="modal-content"
        overlayClassName="modal-overlay"
        isOpen={showDetailsModal}
      >
        <div className="react-modal-content-wrapper">
          <div className="modal-header">
            <h4 className="modal-title"> {service.propertyName} </h4>
            <div
              className="modal-close-icon-container"
              onClick={() => setShowDetailsModal(false)}
            >
              <CloseModalIcon />
            </div>
          </div>
          <div className="property-description-body-wrapper">
            <div className="image-gallery-container">
              <ImageGallery
                lazyLoad={true}
                thumbnailPosition="right"
                items={img}
              />
            </div>
            <div className="property-details-container">
              <div className="price-wrapper">
                <span className="title">Annual Contract:</span>
                <span className="amount"> 85,000 AED/year </span>
              </div>
              {/* <p className="bhk-details"> 2 BHK </p> */}
              <h2 className="amenities-title"> Amenities: </h2>
              <div className="amenities-wrapper">
                {amenities.map((amenity, index) => {
                  return (
                    <p key={index} className="amenity">
                      <Check /> <span> {amenity.name} </span>
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
};
